import AdminLayout from 'components/layouts/AdminLayout';
import './Import.scss';
import { Card, Button } from 'antd';
import Table, { ITable } from '../../components/shared/table/Table';
import { FaArrowLeft } from 'react-icons/fa';
import { FileExcelOutlined } from '@ant-design/icons';
import { TranslateString } from 'Utils/Common';

interface DataMismatchType {
    name: string;
    key: string;
    manager: string;
    num_of_apartment_one: string;
    num_of_apartment_two: string;
    num_of_apartment_three: string;
    num_of_business_space: string;
    num_of_car_one: string;
    num_of_car_two: string;
}

const data = [
    {
        key: '01234',
        name: 'Suscipit vel',
        manager: 'Jarmo',
        num_of_apartment_one: '50',
        num_of_apartment_two: '51',
        num_of_apartment_three: '52',
        num_of_business_space: "53",
        num_of_car_one: "25",
        num_of_car_two: "30",
    },
    {
        key: '01234',
        name: 'Suscipit vel',
        manager: 'Jarmo',
        num_of_apartment_one: '50',
        num_of_apartment_two: '51',
        num_of_apartment_three: '52',
        num_of_business_space: "53",
        num_of_car_one: "25",
        num_of_car_two: "30",
    },
    {
        key: '01234',
        name: 'Suscipit vel',
        manager: 'Jarmo',
        num_of_apartment_one: '50',
        num_of_apartment_two: '51',
        num_of_apartment_three: '52',
        num_of_business_space: "53",
        num_of_car_one: "25",
        num_of_car_two: "30",
    },
    {
        key: '01234',
        name: 'Suscipit vel',
        manager: 'Jarmo',
        num_of_apartment_one: '50',
        num_of_apartment_two: '51',
        num_of_apartment_three: '52',
        num_of_business_space: "53",
        num_of_car_one: "25",
        num_of_car_two: "30",
    }
];


const DataMismatch = (props: any) => {
    const columns: ITable<DataMismatchType>['columns'] = [
        {
            dataIndex: 'key',
            key: 'key',
            title: TranslateString('Customer ID'),
        },
        {
            dataIndex: 'name',
            key: 'name',
            title: TranslateString('Customer Name'),
        },
        {
            dataIndex: 'manager',
            key: 'manager',
            title: TranslateString('Housing Manager Name'),
        },
        {
            dataIndex: 'num_of_apartment_one',
            key: 'num_of_apartment_one',
            title: TranslateString('Number of Apartment (Pat.Dim Data)'),
            render: (row: any) => {
                return (
                    <span className="text-danger fw-bold">{row}</span>
                )
            },
        },
        {
            dataIndex: 'num_of_apartment_two',
            key: 'num_of_apartment_two',
            title: TranslateString('Number of Apartment (Shareholder Data)'),
        },
        {
            dataIndex: 'num_of_business_space',
            key: 'num_of_business_space',
            title: TranslateString('Number of Business Space (Pat.Dim)'),
        },
        {
            dataIndex: 'num_of_apartment_three',
            key: 'num_of_apartment_three',
            title: TranslateString('Number of Apartment (Shareholder Data)'),
        },
        {
            dataIndex: 'name',
            key: 'name',
            title: TranslateString('Number of Car Space (Pat.Dim Data)'),
        },
        {
            dataIndex: 'name',
            key: 'name',
            title: TranslateString('Number of Car Space (Shareholder Data)'),
        }
    ];

    return (
        <>
            <AdminLayout>
                <div className="ant-card ant-card-bordered cu-mb-10 cu-px-10 w-100 text-left">
                    <h4 className="cu-m-0 cu-p-0">
                        <button className="ant-btn cu-border-0 cu-btn"><FaArrowLeft style={{ fontWeight: 900, fontSize: '18px' }} /></button>
                        &nbsp;
                        <button className="ant-btn cu-border-0 cu-btn h4">{TranslateString('Shareholder data mismatch')}</button>
                    </h4>
                </div>
                <Card className="cu-table-small">
                    <div className='text-left'>
                        <Button
                            type="primary"
                            onClick={() => {
                            }}
                            className="border border-success bg-white text-dark cu-btn-margin"
                        >
                            <div className='d-inline-flex' >
                                <FileExcelOutlined style={{ fontSize: '16px', color: "#003d3b", padding: "4px", fontWeight: "bold" }} /><p style={{ color: "#003d3b" }} className='cu-text-large'>{TranslateString('Export')}</p>
                            </div>

                        </Button>
                    </div>
                    <div className='cu-table-border'>
                        <Table
                            columns={columns}
                            data={data}
                        />
                    </div>
                </Card>
            </AdminLayout>
        </>
    );
};
export default DataMismatch;